<template>
  <div class="home" style="height: 100vh; position: relative; overflow: hidden">
    <div class="login-container flip-animation">
      <div class="welcome-section">
        <el-image
          :src="imageUrl"
          style="width: 70px; height: 70px; border-radius: 20px"
        >
        </el-image>
        <h2 style="font-size: 24px; color: white">楼宇设备智能管理平台</h2>
        <span>{{ ProjectInfo.Property_Company }}</span>
        <p>Smart Equipment Management Platform</p>
      </div>
      <div class="login-section">
        <el-tabs v-model="activeName">

          <el-tab-pane label="运维登录" name="2">
            <div class="login-form">
              <h3>欢迎，请登录系统</h3>
              <el-form
                ref="ruleForm1"
                :model="ruleForm1"
                @submit.native.prevent
                label-width="70px"
                label-position="left"
                v-loading="loading"
              >
                <el-form-item prop="Number" label="用户名">
                  <el-input
                    v-model="ruleForm1.Number"
                    auto-complete="off"
                    placeholder="请输入用户名"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="Cipher" label="密码">
                  <el-input
                    v-model="ruleForm1.Cipher"
                    auto-complete="off"
                    placeholder="请输入密码"
                    type="password"
                    show-password
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-checkbox v-model="checked">记住密码</el-checkbox>
                  <!-- <el-link style="float: right">忘记密码?</el-link> -->
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    @click="loginForm(2)"
                    style="width: 100%"
                    >登录</el-button
                  >
                </el-form-item>
                <!-- <el-form-item>
            <el-button type="info" @click="loginForm(2)" style="width: 100%"
              >登录移交后</el-button
            >
          </el-form-item> -->
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="审核登录" name="1">
            <div class="login-form">
              <h3>欢迎，请登录系统</h3>
              <el-form
                ref="ruleForm1"
                :model="ruleForm1"
                @submit.native.prevent
                label-width="70px"
                label-position="left"
                v-loading="loading"
              >
                <el-form-item prop="Number" label="用户名">
                  <el-input
                    v-model="ruleForm1.Number"
                    auto-complete="off"
                    placeholder="请输入用户名"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="Cipher" label="密码">
                  <el-input
                    v-model="ruleForm1.Cipher"
                    auto-complete="off"
                    placeholder="请输入密码"
                    type="password"
                    show-password
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-checkbox v-model="checked">记住密码</el-checkbox>
                  <!-- <el-link style="float: right">忘记密码?</el-link> -->
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    @click="loginForm(1)"
                    style="width: 100%"
                    >登录</el-button
                  >
                </el-form-item>
                <!-- <el-form-item>
            <el-button type="info" @click="loginForm(2)" style="width: 100%"
              >登录移交后</el-button
            >
          </el-form-item> -->
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- <div class="footer">
      <p>
        <span style="font-weight: bold">ICP备案号：</span
        ><span style="margin-right: 20px">京ICP备2021033771号</span>
        <span style="font-weight: bold"
          >技术支持<i class="el-icon-phone" style="color: red"></i>：</span
        ><span>13120268450</span>
      </p>
      <p>
        <span style="font-weight: bold">Copyright &copy;</span
        ><span style="margin-right: 20px">2021-{{ new Date().getFullYear() }}</span>
        <span style="font-weight: bold">版权所有：</span
        ><span>铂诺客智能科技（北京）有限公司</span>
      </p>
    </div> -->
  </div>
</template>

<script>
import TokenCache from '@/utils/cache/TokenCache'
import { mapState } from 'vuex'

import '@/assets/Index/index.css'
import { Loading } from 'element-ui'

let checkLoginPhone = (rule, value, callback) => {
  let reg = /^1[345789]\d{9}$/
  if (!reg.test(value)) {
    callback(new Error('请输入11位手机号'))
  } else {
    callback()
  }
}
let checkRegisterPhone = (rule, value, callback) => {
  let reg = /^1[345789]\d{9}$/
  if (!reg.test(value)) {
    callback(new Error('请输入11位手机号'))
  } else {
    callback()
  }
}
export default {
  name: 'Index',
  props: ['centerDialogVisibleSecond'],
  components: {},
  data() {
    // 登录
    const validatecip = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.ruleForm1.checkPass !== '') {
          this.$refs.ruleForm1.validateField('checkPass')
        }
        callback()
      }
    }

    // 注册
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm2.pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      activeName: '2',
      ProjectInfo: {},
      userInfo: {},
      showLoad: false,
      codeValue: document.location.origin + '/XunJianGo',
      codeValueIOS: document.location.origin + '/XunJianGoIOS',
      imageUrl: require('@/assets/logo.png'), //icon路径
      loading: false,
      loginAndRegisterShow: false,
      showPrise: true,
      showRentPrise: true,
      NoToken: true, //无Token
      ruleForm1: {
        Number: '',
        Cipher: '',
      },
      rules1: {
        Number: [
          {
            required: true,
            message: '请输入账号',

            trigger: 'blur',
          },
        ],
        Cipher: [
          {
            validator: validatecip,
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          },
        ],
      },
      ruleForm2: {
        smscode: '',
        tel: '',
        word: '',
        pass: '',
        checkPass: '',
      },
      rules2: {
        smscode: [
          { required: true, message: '请输入图片验证码', trigger: 'blur' },
        ],
        tel: [
          {
            required: true,
            message: '请输入手机号码',
            validator: checkRegisterPhone,
            trigger: 'blur',
          },
        ],
        word: [
          { required: true, message: '请输入手机验证码', trigger: 'blur' },
        ],
        pass: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        checkPass: [
          { required: true, validator: validatePass, trigger: 'blur' },
        ],
      },
      dialogVisible: false,
      dialogVisibleDownload: false,
      timer: null,
      oneMinute: 60,
      flag: false, // 密码可视
      resetflag: false, // 密码可视
      checked: true,
      disabled: true,
      Codedisabled: true,
      buttonText: '',
      isDisabled: false,
      key: '',
      url: '',
      appid: 'wxef625270eda5492e',
      scope: 'snsapi_login',
      codeData: {},
      unionid: null,
    }
  },
  methods: {
    getUserInfo() {
      const loadingInstance = Loading.service({
        fullscreen: true,
        text: '系统正在登录中...',
      })
      this.loading = true
      this.$http.post('/Base_Manage/Home/GetOperatorInfo', {}).then((res) => {
        this.loading = false
        loadingInstance.close()
        if (res.Success) {
          this.userInfo = res.Data.UserInfo
          window.localStorage.setItem(
            'userInfo',
            JSON.stringify(res.Data.UserInfo)
          )
          this.$store.commit('setUserInfo', res.Data.UserInfo)
          if (this.userInfo.ProjectStatus != 2) {
            this.$router.replace({ path: '/ProjectInfo?id=' + this.$ProjectId })
          } else {
            this.$store.commit('setMenu', res.Data.Permissions)
            window.localStorage.setItem(
              'Menu',
              JSON.stringify(res.Data.Permissions)
            )
            this.$router.replace({ path: '/Home' })
          }
        }
      })
    },
    // app下载
    // loadApp() {
    //   this.$notify.
    // },
    getTitle() {
      return process.env.VUE_APP_ProjectName
    },

    getProjectInfo() {
      this.$http
        .post(
          '/Base_Manage/Home/GetProjectInfo?ProjectId=' + this.$ProjectId,
          {}
        )
        .then((res) => {
          if (res.Success) {
            this.ProjectInfo = res.Data
            window.localStorage.setItem('ProjectInfo', JSON.stringify(res.Data))
          }
        })
    },
    loginForm(num) {
      if (!this.ruleForm1.Number) {
        return this.$notify.warning('请输入用户名')
      }
      if (!this.ruleForm1.Cipher) {
        return this.$notify.warning('请输入密码')
      }
      const loadingInstance = Loading.service({
        fullscreen: true,
        text: '系统正在登录中...',
      })
      this.loading = true
      this.$http
        .post('/Base_Manage/Home/SubmitLogin', {
          userName: this.ruleForm1.Number,
          password: this.ruleForm1.Cipher,
          ProjectId: this.$ProjectId,
          ProjectStatus: num,
        })
        .then(async (res) => {
          loadingInstance.close()
          this.loading = false

          if (res.Success) {
            TokenCache.setToken(res.Data)

            await this.getUserInfo()
            await this.$store.dispatch('setUser', true)
            // this.$router.replace({ path: "/ProjectInfo?id=1887744400671379456" });
            // if (num == 1) {
            //   window.localStorage.setItem("Befor", 1);
            //   this.$router.replace({ path: "/ProjectInfo" });
            // } else {
            //   window.localStorage.setItem("Befor", 0);
            //   this.$router.replace({ path: "/Home" });
            // }
          } else {
            this.$notify.error(res.Msg)
          }
        })
      // this.$refs.ruleForm1.validate((valid) => {
      //   if (!valid) {
      //     return;
      //   }

      // });
    },
  },
  mounted() {
    console.log('2222222222222222222222222222222222222222')
  },
  created() {
    window.localStorage.clear()
    this.getProjectInfo()
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 888;
  width: 100%;
  text-align: center;
  // background-color: #ffffff;
  /* 设置背景色 */
  padding: 8px 0;
  /* 设置内边距 */
  font-size: 14px;
  /* 设置字体大小 */
  color: #fff;
  /* 设置字体颜色 */
}

.home {
  background: url('~@/assets/bg.jpg') no-repeat center center fixed; // 确保路径正确并设置背景属性
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.login-container {
  display: flex;
  width: 800px;
  height: 500px; /* 设置固定高度 */
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  transform-style: preserve-3d;
  animation: flipIn 1s ease-out forwards;
}

.welcome-section {
  width: 50%;
  background-color: #409eff; // 调整背景色为与登录按钮一致的蓝色
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  color: white;
  & > * {
    margin-bottom: 10px;
  }
}

.welcome-section h2 {
  margin-top: 10px; // 适当调整顶部外边距以提高位置
}

.login-section {
  width: 50%;
  background-color: #ffffff; /* 右侧纯白 */
  // padding: 40px 20px;
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  & > * {
    margin-bottom: 20px;
  }
}
::v-deep .el-tabs {
  height: 100%;
  margin: 0;
}
::v-deep .el-tabs__nav {
  width: 100% !important;
}
::v-deep .el-tabs__item {
  width: 50% !important;
  text-align: center;
  font-size: 18px;
  padding: 0 !important;
  height: 50px !important;
  line-height: 50px !important;
}
::v-deep .el-tabs__active-bar {
  width: 50% !important;
}
::v-deep .el-tabs__content {
  height: calc(100% - 66px);
}
.el-tabs__content .el-tab-pane {
  height: 100%;
  position: relative;
}
.login-form {
  margin-top: 10%;
  width: 100%;
  h3 {
    margin-bottom: 20px;
  }
}
.login-form {
  padding: 20px;
}
@keyframes flipIn {
  from {
    transform: rotateY(-90deg);
    opacity: 0;
  }
  to {
    transform: rotateY(0);
    opacity: 1;
  }
}
</style>
